import React from "react";
import { IPanelProps, Panel } from "core/decorators/Panel";
import PlaylistCofigPanel from "./PlaylistTablePanelConfig";
import labelProvider from "./Playlist.labels";
import StringUtil from "core/util/StringUtil";
import { IPageableListQuery } from "common/models/IPageableListQuery";
import { FavoritePlaylist } from "./entities/FavoritePlaylist";
import { Field } from "typegraph";
import CountResult from "common/entities/CountResult";
import Query from "core/api/QueryComponent";
import NonIdealState from "common/fragments/NonIdealState";
import DataTable from "common/views/table/DataTable";
import { BlockView } from "common/views/block/BlockView.view";
import PagingView from "common/views/paging/Paging.view";
import * as columns from "./fragments/FavoritePlaylistFragments";

const { Labels } = labelProvider;

interface IPlaylistState {
	pageNumber: number;
	pageSize: number;
}

function mapParams(params: any) {
	return { params };
}

class PlaylistQuery implements IPageableListQuery<FavoritePlaylist> {
	@Field({
		entity: FavoritePlaylist,
		params: mapParams,
		aliasFor: "article_playlist_many"
	})
	public entities: null | FavoritePlaylist[];

	@Field({
		entity: CountResult,
		params: mapParams,
		aliasFor: "article_playlist_count"
	})
	public count: CountResult;
}

@Panel({
	id: "playlist-table",
	configClass: PlaylistCofigPanel,
	pageParams: true,
	labelProvider
})
export class PlaylistTablePanel extends React.PureComponent<
	IPanelProps<PlaylistCofigPanel, IPlaylistState>
> {
	public render() {
		const { config, pageParams } = this.props;

		const p = Object.entries(config.playlistParams || {}).reduce(
			(a, [k, v]) => {
				a[k] = v;
				return a;
			},
			{}
		);

		if (config.pageSize) {
			p["pageSize"] = config.pageSize;
		}

		if (pageParams["pageSize"]) {
			p["pageSize"] = StringUtil.toInteger(
				pageParams["pageSize"],
				p["pageSize"]
			);
		}

		if (!p["pageSize"]) {
			p["pageSize"] = 6;
		}

		p["playlistPageNumber"] = StringUtil.toInteger(
			pageParams["playlistPageNumber"],
			0
		);
		if (p["playlistPageNumber"] < 1) {
			p["playlistPageNumber"] = 0;
		}

		return (
			<div>
				<Query.Root entity={PlaylistQuery} args={p}>
					{({ loading, data }) => {
						if (
							!loading &&
							(data == null ||
								data.entities == null ||
								data.entities.length === 0)
						) {
							return (
								<NonIdealState
									title={<Labels.PlaylistEmpty />}
									description={
										<Labels.PlaylistEmptyDescription />
									}
								/>
							);
						}

						const lst = (data && data.entities) || null;

						return (
							<React.Fragment>
								<DataTable
									viewKeyPrefix="results"
									data={lst}
									params={p}
									entity={FavoritePlaylist}
									getId={sub => sub.id}
									columns={Object.values(columns)}
								/>
								<BlockView viewKey="paging.block">
									<PagingView
										viewKey="paging"
										setPageNumber={pageNumber =>
											this.props.actions.pushPageParam(
												"playlistPageNumber",
												pageNumber.toString()
											)
										}
										total={(data && data.count.count) || 0}
										pageNumber={p["playlistPageNumber"]}
										pageSize={p["pageSize"]}
									/>
								</BlockView>
								<hr />
							</React.Fragment>
						);
					}}
				</Query.Root>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/favorites/PlaylistTable.panel.tsx